<template>
  <div>
    <Menu
      mode="horizontal"
      :active-name="menu_name"
      @on-select="selectMenu"
      style="width: 100%"
    >
      <div v-for="(v, k) in menus" :key="k" style="display: inline-block" v-auth="v.auth">
        <MenuItem
          :name="v.name"
          @click="v.onClick"
          v-show="v.show === true ? false : true"
        >
          <Badge
            :overflow-count="10000000"
            v-if="v.badge && v.badge.count"
            :count="v.badge.count"
            :offset="[18, -3]"
          >
            {{ v.label }}
          </Badge>
          <span v-if="!(v.badge && v.badge.count)">
            {{ v.label }}
          </span>
        </MenuItem>
      </div>
    </Menu>
    <div class="service_box" id="printArea" style="page-break-before: always">
      <div class="service_title">{{ customerName }}核算报告</div>
      <div class="service_nav">
        <div class="service_nav_date noprint">
          <div class="service_nav_date_left">请选择日期：</div>
          <el-date-picker
            v-model="classesDate"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            :default-time="['00:00:00', '23:59:59']"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="onClassSesDate"
          >
          </el-date-picker>
          <div class="service_nav_date_left mode">模式: 组合模式</div>
          <!--  <el-select v-model="type" placeholder="请选择" @change="ontype">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        </div>
        <div class="service_nav_date_str">
          日期：{{ dayjsS(classesDate[0]).format("YYYY日MM月DD日") }} -
          {{ dayjsS(classesDate[1]).format("YYYY日MM月DD日") }}
        </div>
        <div class="service_nav_right noprint">
          <div class="service_nav_right_email">
            <Button type="info" @click="handleShenpi"> 发送邮箱 </Button>
          </div>
          <div class="service_nav_right_print">
            <Button type="info" v-print="printObject"> 打印 </Button>
          </div>
          <div class="service_nav_right_email">
            <Button type="info" @click="onExport()"> 导出 </Button>
          </div>
        </div>
      </div>
      <div class="service_main">
        <el-table
          :data="tableData"
          style="width: 100%; min-height: calc(100vh - 500px)"
          v-loading="loading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-table-column
            type="index"
            :index="indexMethod"
            align="center"
            label="序号"
            width="80"
          >
          </el-table-column>
          <el-table-column prop="checkDeskName" label="核算科室" min-width="180">
          </el-table-column>
          <el-table-column
            prop="facilityCount"
            align="center"
            label="设备数量(台)"
            min-width="120"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.facilityCount ? scope.row.facilityCount : 0 }}
              </div>
            </template>
          </el-table-column>
          <!--  <el-table-column
          prop="facilityInsertCount"
          align="center"
          label="新增(个)"
          min-width="100"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.facilityInsertCount ? scope.row.facilityInsertCount : 0 }}
            </div>
          </template>
        </el-table-column> -->
          <el-table-column
            prop="facilityApportionedAmount"
            align="center"
            label="分摊金额"
            min-width="100"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.facilityApportionedAmount
                    ? scope.row.facilityApportionedAmount.toFixed(2)
                    : 0
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="consumablesCost"
            align="center"
            label="耗材费用"
            min-width="120"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.consumablesCost ? scope.row.consumablesCost.toFixed(2) : 0 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="consumablesApportionedAmount"
            align="center"
            label="分摊金额"
            min-width="100"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.consumablesApportionedAmount
                    ? scope.row.consumablesApportionedAmount.toFixed(2)
                    : 0
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="totalApportionedAmount"
            align="center"
            label="合计"
            min-width="100"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.totalApportionedAmount
                    ? scope.row.totalApportionedAmount.toFixed(2)
                    : 0
                }}元
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Modal title="提示" v-model="modal" class-name="vertical-center-modal" width="400">
        <h4>未绑定设备数量: {{ unBindFacilityCount }}</h4>
        <p style="height: 10px"></p>
        <h4>未绑定耗材领用工单数量: {{ unBindConsumableReceiveCount }}</h4>
      </Modal>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import youxiang from "./youxiang.vue";
import config from "../../../config";
export default {
  components: {
    youxiang,
  },
  data() {
    return {
      menu_name: "",
      menus: [
        {
          label: "成本",
          name: "Accountingreport",
          auth: "/admin/Accounting/main",
        },
        {
          label: "科室",
          name: "AccountingList",
          auth: "/admin/Accounting/main",
        },
        {
          label: "核算设置",
          name: "Accountinginstall",
          auth: "/admin/Accounting/main",
        },
      ],
      modal: false,
      type: "1",
      options: [
        {
          value: "1",
          label: "耗材模式",
        },
        {
          value: "2",
          label: "按台模式",
        },
      ],
      tableData: [],
      list: [],
      classesDate: "",
      begin: "",
      end: "",
      customerName: "",
      loading: false,
      dayjsS: dayjs,
      printObject: {
        id: "printArea",
        popTitle: window.localStorage.getItem("customerName") + "核算报告",
        manualPageBreak: true,
      },
      pickerOptions: {
        disabledDate: (time) => {
          let current_time = dayjs(new Date()).format("YYYY-MM-DD ") + "23:59:59"; //时间日期为：‘当前日期 23:59:59’
          let t = new Date(current_time).getTime(); //‘当前日期 23:59:59’的时间戳
          return time.getTime() > t;
        },
      },
      unBindFacilityCount: 0,
      unBindConsumableReceiveCount: 0,
    };
  },
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
    this.classesDate = [
      dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
      dayjs().format("YYYY-MM-DD HH:mm:ss"),
    ];
    this.begin = dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss");
    this.end = dayjs().format("YYYY-MM-DD HH:mm:ss");
    this.load();
    this.customerName = window.localStorage.getItem("customerName");
  },

  methods: {
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    async load() {
      let q = {
        begin: "",
        end: "",
      };
      q.begin = this.begin;
      q.end = this.end;
      q.type = 0;
      this.loading = true;
      let res = await $utils.api.load(
        // "/admin/system/check/checkReport",
        "/admin/system/check/checkCombinationModeReport",
        q,
        "get"
      );
      if (res.code == 200) {
        this.loading = false;
        this.tableData = res.data.costCheckRepoortResponses;
        let data = res.data;
        const totals = {
          checkDeskName: "总计", // 可以在这里设置总计行的名称
          facilityCount: 0,
          facilityApportionedAmount: 0,
          consumablesCost: 0,
          consumablesApportionedAmount: 0,
          totalApportionedAmount: 0,
        };
        totals.facilityCount += data.allFacilityCount || 0;
        totals.facilityApportionedAmount += data.facilityTotal || 0;
        totals.consumablesCost += data.allConsumablesCost || 0;
        totals.consumablesApportionedAmount += data.consumablesTotal || 0;
        totals.totalApportionedAmount += data.totalMoney || 0;
        this.tableData.unshift(totals);
        this.unBindConsumableReceiveCount = data.unBindConsumableReceiveCount;
        this.unBindFacilityCount = data.unBindFacilityCount;
        this.modal = true;
      }
    },
    async onExport() {
      let q = {
        begin: "",
        end: "",
      };
      q.begin = this.begin;
      q.end = this.end;
      q.type = this.type;
      this.loading = true;
      let res = await $utils.api.load(
        "/admin/system/check/costAccountingReportExport",
        q,
        "get"
      );
      if (res.code == 200) {
        window.location.href =
          config.API_HOST + `/admin/common/download?fileName=${res.msg}`;
        this.loading = false;
      }
    },
    handleShenpi(row) {
      this.$Modal.success({
        closable: true,
        title: "发送至邮箱",
        width: "600px",
        height: "120px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <youxiang
              begin={this.begin}
              end={this.end}
              type={this.type}
              onClose={() => this.onClose()}
            >
              {" "}
            </youxiang>
          );
        },
      });
    },
    onClassSesDate(e) {
      this.begin = e[0];
      this.end = e[1];
      this.load();
    },
    ontype(e) {
      this.type = e;
      this.load();
    },
    indexMethod(index) {
      return index;
    },
  },
};
</script>

<style lang="less" media="print">
.service_box {
  // min-height: calc(100vh - 100px);

  .service_title {
    width: 100%;
    font-size: 28px;
    text-align: center;
    font-weight: 800;
  }

  .service_nav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 20px 0;

    .service_nav_date {
      display: flex;
      align-items: center;
      width: 50%;

      .service_nav_date_left {
        margin-right: 10px;
      }
      .mode {
        margin-left: 10px;
      }

      .el-date-editor .el-range-separator {
        width: 10%;
      }
    }

    .service_nav_date_str {
      display: none;
      font-size: 16px;
    }

    .service_nav_right {
      display: flex;
      width: 40%;
      justify-content: right;
      align-items: center;
      padding: 0 20px;

      .service_nav_right_print {
        font-size: 16px;
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }

  .el-table tr:nth-child(1) {
    background: #66d4ff;
    font-weight: 600;
  }
}

@page {
  size: auto;
  margin: 3mm;
}

@media print {
  html {
    background-color: #ffffff;
    height: auto !important;
    margin: 0px;
  }

  body {
    border: solid 1px #ffffff;
    margin: 10mm 15mm 10mm 15mm;
  }

  .noprint {
    display: none !important;
  }

  .service_nav_date_str {
    display: block !important;
  }

  #printArea {
    width: 100%;
    // height: 100vh !important;
    overflow: visible !important;
  }

  .service_main {
    width: 100%;
  }

  #printArea table {
    table-layout: auto !important;
  }

  #printArea .el-table tr:nth-child(1) {
    background: #66d4ff !important;
    font-weight: 600;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }

  // #printArea .el-table--enable-row-transition .el-table__body td.el-table__cell {
  //     background: #66d4ff !important;
  // }

  // #printArea .el-table {
  //     height: 100vh !important;
  // }

  #printArea .el-table__header-wrapper .el-table__header {
    width: 100% !important;
  }

  #printArea .el-table__body-wrapper .el-table__body {
    width: 100% !important;
  }

  #printArea #pagetable table {
    table-layout: fixed !important;
  }
}
</style>
